import Image from 'next/image'

const CardImage = ({
    name,
    cmsImageUrl,
    isPortraitImage = false,
}: {
    cmsImageUrl: string
    isPortraitImage?: boolean
    name: string
}) => {
    const imageDimensions = isPortraitImage
        ? { width: 280, height: 440 }
        : { width: 180, height: 90 }

    return (
        <Image
            src={cmsImageUrl}
            alt={`${name} credit card`}
            width={imageDimensions.width}
            height={imageDimensions.height}
            style={{
                width: '100%',
                height: 'auto',
            }}
        />
    )
}

export default CardImage
